import financial from '../../assets/images/financial.png'
import agriBusiness from '../../assets/images/agriBusiness.png'
import business from '../../assets/images/business.png'
import products from '../../assets/images/products.png'
import shopping from '../../assets/images/shopping.png'
import digital from '../../assets/images/digital.png'
import logistics from '../../assets/images/logistics.png'
import others from '../../assets/images/others.png'

export const webzenServices = [
    {
        img: financial,
        head: 'Financial Investment',
        text: 'Webzen invests in young and growing businesses with strong market potentials. A proven market, competent management and clear exit routes key conditions for our investment.'
    },
    {
        img: agriBusiness,
        head: 'Agribusiness Project Development',
        text: 'We continuously seek to partner with competent agribusiness practitioners, organizations   and agencies towards creating and managing profitable agricultural projects within and outside Nigeria.'
    },
    {
        img: business,
        head: 'Business Advisory',
        text: 'Leveraging on the pool of experience available with the company and the group, we are well positioned to provide qualitative business advisory and business support services to agribusinesses, food processing and related businesses towards ensuring business survival and growth.'
    },
    {
        img: products,
        head: 'Products Distribution',
        text: 'As part of Business Support to our investee and partner firms, we actively engage in the distribution of agricultural and food products across Nigeria leveraging on existing and constantly expanding distribution chain. We presently have a ‘Healthy Basket’ of food items being promoted across our distribution channels.'
    },
]


export const hawareeServices = [
    {
        img: shopping,
        head: 'Online Shopping',
        text: 'Beyond the traditional online shopping, we are poised to introduce virtual reality retail giving our users a deeper shopping satisfaction experience.'
    },
    {
        img: digital,
        head: 'Digital Services',
        text: 'We intend to make the hawaree.com platform a-one-stop shop where users can make seamlessly access digital services such as bills payments (utilities, entertainment); download music, buy airtime and data, create gift cards, etc.'
    },
    {
        img: logistics,
        head: 'Logistics Services',
        text: 'Provision of prompt and secured delivery services for our stakeholders.'
    },
    {
        img: others,
        head: 'Other Added Services',
        text: 'Using technology, we are promoting a savings culture where users/shoppers saves per purchases made on the platform.'
    },
]